export const EvaluationSkillCriterion = {
    path: '/evaluation_skill_criterion',
    name: 'evaluation_skill_criterion',
    component: () => import('@/views/Evaluation/Measure/EvaluationSkillMeasurePage.vue'),
    props: {
        type: 'EVALUATION_SKILL',
    },
    children: [
        {
            path: '/evaluation_skill_criterion/add',
            name: 'evaluation_skill_criterion.add',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_criterion/edit/:id',
            name: 'evaluation_skill_criterion.edit',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_criterion/delete/:id',
            name: 'evaluation_skill_criterion.delete',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
        {
            path: '/evaluation_skill_criterion/view/:id',
            name: 'evaluation_skill_criterion.view',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_SKILL',
            }
        },
    ]
}